module.exports = __webpack_public_path__ + "img/8.d98de35c.webp";